var wc_all_options = async () => {
  const wc_money_format = document.querySelector('#th_shop_money').getAttribute('content')
  const $th_app_ajax_url2 = 'https://bundle.thimatic-apps.com/';
  // const $th_app_ajax_url2 = 'https://csv.rivyo.com/product-bundle-ci/fronted/';
  const wc_formatMoney = (cents) => {
    if (typeof cents == 'string') { cents = cents.replace('.',''); }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (wc_money_format || this.money_format);
  
    function defaultOption(opt, def) {
       return (typeof opt == 'undefined' ? def : opt);
    }
  
    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, ',');
      decimal   = defaultOption(decimal, '.');
  
      if (isNaN(number) || number == null) { return 0; }
  
      number = (number/100.0).toFixed(precision);
  
      var parts   = number.split('.'),
          dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
          cents   = parts[1] ? (decimal + parts[1]) : '';
  
      return dollars + cents;
    }
  
    switch(formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
    }
  
    return formatString.replace(placeholderRegex, value);
  };
  const updatePricing = (selfBox) => {
    var wc_price = 0;
    var wc_discounted_price = 0;
    var discount_type = parseInt(selfBox.getAttribute('data-discount-type'));
    var discount_value = Number(selfBox.getAttribute('data-discount'));
    if (selfBox.classList.toString().includes('th_pb_qty_bundle_l2_grid_inner') || selfBox.classList.toString().includes('th_pb_qty_layout_grid_column_section')) {
      var prd_quantity = parseInt(selfBox.getAttribute('data-quantity'));
      selfBox.querySelectorAll('.wc_main_variants').forEach(function(self) {
        var value = self.options[self.selectedIndex].text;
        var price = parseInt(self.options[self.selectedIndex].getAttribute('data-price'));
        if (selfBox.classList.toString().includes('th_pb_qty_layout_grid_column_section')) {
          var single_discounted_price = 0;
          if (discount_type == 0) {
            single_discounted_price = price - ((price * discount_value) / 100);
          } else {
            single_discounted_price = price - ((100 * discount_value) / prd_quantity);
          }
          if (discount_value > 0) {
            self.closest('.wc_common_product_grid_class').querySelector('.th_pb_qty_grid_old_price').style.display = 'inline-block';
            self.closest('.wc_common_product_grid_class').querySelector('.th_pb_qty_grid_old_price').innerHTML = '<span class="money transcy-money">' + wc_formatMoney(price) + '</span>';
            self.closest('.wc_common_product_grid_class').querySelector('.th_pb_qty_grid_sale_price').innerHTML = '<span class="money transcy-money">' + wc_formatMoney(single_discounted_price) + '</span>';
          } else {
            self.closest('.wc_common_product_grid_class').querySelector('.th_pb_qty_grid_old_price').style.display = 'none';
            self.closest('.wc_common_product_grid_class').querySelector('.th_pb_qty_grid_sale_price').innerHTML = '<span class="money transcy-money">' + wc_formatMoney(price) + '</span>';
          }
        }
        wc_price += price;
      });
      if (discount_type == 0) {
        wc_discounted_price = wc_price - ((wc_price * discount_value) / 100);
      } else {
        wc_discounted_price = wc_price - (100 * discount_value);
      }
      if (selfBox.querySelector('.wc_total_sale_price')) {
        selfBox.querySelector('.wc_total_sale_price').innerHTML = '<span class="money transcy-money">' + wc_formatMoney(wc_discounted_price) + '</span>';
      }
      if (selfBox.querySelector('.wc_total_old_price')) {
        selfBox.querySelector('.wc_total_old_price').innerHTML = '<span class="money transcy-money">' + wc_formatMoney(wc_price) + '</span>';
      }
    } else {
      selfBox.querySelectorAll('.wc_main_variants').forEach(function(self){
        var value = self.options[self.selectedIndex].text;
        var price = parseInt(self.options[self.selectedIndex].getAttribute('data-price'));
        var qty_price = price * parseInt(self.closest('.wc_common_product_grid_class').querySelector('.wc_qty_prd').getAttribute('data-qty'));
        var single_discounted_price = 0;
        if (discount_type == 0) {
          single_discounted_price = price - ((price * discount_value) / 100);
        } else {
          single_discounted_price = price - ((100 * discount_value) / 1);
        }
        if (discount_value > 0) {
          self.closest('.wc_common_product_grid_class').querySelector('.th_pb_old_price').style.display = 'inline-block';
          self.closest('.wc_common_product_grid_class').querySelector('.th_pb_old_price').innerHTML = '<span class="money transcy-money">' + wc_formatMoney(price) + '</span>';
          self.closest('.wc_common_product_grid_class').querySelector('.th_pb_main_price').innerHTML = '<span class="money transcy-money">' + wc_formatMoney(single_discounted_price) + '</span>';
        } else {
          self.closest('.wc_common_product_grid_class').querySelector('.th_pb_old_price').style.display = 'none';
          self.closest('.wc_common_product_grid_class').querySelector('.th_pb_main_price').innerHTML = '<span class="money transcy-money">' + wc_formatMoney(price) + '</span>';
        }
        wc_price += qty_price;
      });
      if (discount_type == 0) {
        wc_discounted_price = wc_price - ((wc_price * discount_value) / 100);
        var wc_save_price = wc_price - wc_discounted_price;
      } else {
        wc_discounted_price = wc_price - (100 * discount_value);
        var wc_save_price = wc_price - wc_discounted_price;
      }
      if (selfBox.closest('.wc_pb_innercode_sections').querySelector('.wc_total_sale_price')) {
        selfBox.closest('.wc_pb_innercode_sections').querySelector('.wc_total_sale_price').innerHTML = '<span class="money transcy-money">' + wc_formatMoney(wc_discounted_price) + '</span>';
      }
      if (selfBox.closest('.wc_pb_innercode_sections').querySelector('.wc_total_old_price')) {
        selfBox.closest('.wc_pb_innercode_sections').querySelector('.wc_total_old_price').innerHTML = '<span class="money th_pb_line_through">' + wc_formatMoney(wc_price) + '</span>';
      }
      if (wc_save_price > 0) {
        selfBox.closest('.wc_pb_innercode_sections').querySelector('.th_pb_total_save_price').innerHTML = '<span class="money">' + wc_formatMoney(wc_save_price) + '</span>';
        selfBox.closest('.wc_pb_innercode_sections').querySelector('.th_pb_total_save_price').style.display = 'inline-flex';
      } else {
        selfBox.closest('.wc_pb_innercode_sections').querySelector('.th_pb_total_save_price').style.display = 'none';
      }
    }
  }
  document.querySelectorAll('.th_pb_qty_bundle_l2_title_label').forEach(function(self){
     self.addEventListener('click', function(){
         self.closest('.th_pb_qty_bundle_l2_grid_start').querySelectorAll('.th_pb_qty_bundle_l2_grid_inner').forEach(function(selfInner){
             selfInner.querySelector('.th_pb_qty_bundle_l2_title_radio_cls').checked = false;
             selfInner.classList.remove('th_pb_qty_bundle_l2_selected');
             selfInner.classList.remove('wc_this_is_active_at_the_moment');
         });
         self.closest('.th_pb_qty_bundle_l2_grid_inner').classList.add('th_pb_qty_bundle_l2_selected');
         self.closest('.th_pb_qty_bundle_l2_grid_inner').classList.add('wc_this_is_active_at_the_moment');
         self.closest('.th_pb_qty_bundle_l2_grid_inner').querySelector('.th_pb_qty_bundle_l2_title_radio_cls').checked = true;
         updateErrorMessage(self.closest('.wc_main_comman_class'))
     });
  });
  document.querySelectorAll('.wc_main_variants').forEach(function(self){
    var option1 = self.options[self.selectedIndex].getAttribute('data-option1');
    var option2 = self.options[self.selectedIndex].getAttribute('data-option2');
    var option3 = self.options[self.selectedIndex].getAttribute('data-option3');
    if (option1) {
      if (self.closest('.wc_common_product_grid_class').querySelectorAll('.wc_variant_options_row .wc_variant__single_options_row')[0]?.querySelector('.wc_swatch_button[value="'+ option1 +'"]')) {
        self.closest('.wc_common_product_grid_class').querySelectorAll('.wc_variant_options_row .wc_variant__single_options_row')[0].querySelectorAll('.wc_swatch_button').forEach(function(selfInner){
          selfInner.checked = false;
        });
        self.closest('.wc_common_product_grid_class').querySelectorAll('.wc_variant_options_row .wc_variant__single_options_row')[0].querySelector('.wc_swatch_button[value="'+ option1 +'"]').checked = true;
      }
      if (self.closest('.wc_common_product_grid_class').querySelectorAll('.wc_variant_options_row .wc_variant__single_options_row')[0]?.querySelector('.wc_single_option_selector option[value="'+ option1 +'"]')) {
        self.closest('.wc_common_product_grid_class').querySelectorAll('.wc_variant_options_row .wc_variant__single_options_row')[0].querySelectorAll('.wc_single_option_selector option').forEach(function(selfInner){
          selfInner.selected = false;
        });
        self.closest('.wc_common_product_grid_class').querySelectorAll('.wc_variant_options_row .wc_variant__single_options_row')[0].querySelector('.wc_single_option_selector option[value="'+ option1 +'"]').selected = true;
      }
    }
    if (option2) {
      if (self.closest('.wc_common_product_grid_class').querySelectorAll('.wc_variant_options_row .wc_variant__single_options_row')[1]?.querySelector('.wc_swatch_button[value="'+ option2 +'"]')) {
        self.closest('.wc_common_product_grid_class').querySelectorAll('.wc_variant_options_row .wc_variant__single_options_row')[1].querySelectorAll('.wc_swatch_button').forEach(function(selfInner){
          selfInner.checked = false;
        });
        self.closest('.wc_common_product_grid_class').querySelectorAll('.wc_variant_options_row .wc_variant__single_options_row')[1].querySelector('.wc_swatch_button[value="'+ option2 +'"]').checked = true;        
      }
      if (self.closest('.wc_common_product_grid_class').querySelectorAll('.wc_variant_options_row .wc_variant__single_options_row')[1]?.querySelector('.wc_single_option_selector option[value="'+ option2 +'"]')) {
        self.closest('.wc_common_product_grid_class').querySelectorAll('.wc_variant_options_row .wc_variant__single_options_row')[1].querySelectorAll('.wc_single_option_selector option').forEach(function(selfInner){
          selfInner.selected = false;
        });
        self.closest('.wc_common_product_grid_class').querySelectorAll('.wc_variant_options_row .wc_variant__single_options_row')[1].querySelector('.wc_single_option_selector option[value="'+ option2 +'"]').selected = true;
      }
    }
    if (option3) {
      if (self.closest('.wc_common_product_grid_class').querySelectorAll('.wc_variant_options_row .wc_variant__single_options_row')[2]?.querySelector('.wc_swatch_button[value="'+ option3 +'"]')) {
        self.closest('.wc_common_product_grid_class').querySelectorAll('.wc_variant_options_row .wc_variant__single_options_row')[2].querySelectorAll('.wc_swatch_button').forEach(function(selfInner){
          selfInner.checked = false;
        });
        self.closest('.wc_common_product_grid_class').querySelectorAll('.wc_variant_options_row .wc_variant__single_options_row')[2].querySelector('.wc_swatch_button[value="'+ option3 +'"]').checked = true;
      }
      if (self.closest('.wc_common_product_grid_class').querySelectorAll('.wc_variant_options_row .wc_variant__single_options_row')[2]?.querySelector('.wc_single_option_selector option[value="'+ option3 +'"]')) {
        self.closest('.wc_common_product_grid_class').querySelectorAll('.wc_variant_options_row .wc_variant__single_options_row')[2].querySelectorAll('.wc_single_option_selector option').forEach(function(selfInner){
          selfInner.selected = false;
        });
        self.closest('.wc_common_product_grid_class').querySelectorAll('.wc_variant_options_row .wc_variant__single_options_row')[2].querySelector('.wc_single_option_selector option[value="'+ option3 +'"]').selected = true;
      }
    }
  });
  document.querySelectorAll('.wc_swatch_button').forEach(function(self){
    self.addEventListener('change', function(event){
      event.preventDefault();
      event.stopPropagation();
      var optionsLength = self.closest('.wc_variant_options_row').querySelectorAll('.wc_variant__single_options_row').length;
      if (optionsLength == 3) {
        var option1 = self.closest('.wc_variant_options_row').querySelectorAll('.wc_variant__single_options_row')[0].querySelector('.wc_swatch_button:checked').value;
        var option2 = self.closest('.wc_variant_options_row').querySelectorAll('.wc_variant__single_options_row')[1].querySelector('.wc_swatch_button:checked').value;
        var option3 = self.closest('.wc_variant_options_row').querySelectorAll('.wc_variant__single_options_row')[2].querySelector('.wc_swatch_button:checked').value;
        self.closest('.wc_common_product_grid_class').querySelectorAll('.wc_main_variants option').forEach(function(selfInner){
          var select_option1 = selfInner.getAttribute('data-option1');
          var select_option2 = selfInner.getAttribute('data-option2');
          var select_option3 = selfInner.getAttribute('data-option3');
          if (option1 == select_option1 && option2 == select_option2 && option3 == select_option3) {
              self.closest('.wc_common_product_grid_class').querySelectorAll('.wc_main_variants option').forEach(function(selfInner2){
                selfInner2.removeAttribute('selected');
              });
              selfInner.setAttribute('selected', 'selected');
              updatePricing(self.closest('.wc_main_grid_inner'));
          }
        });
      }
      if (optionsLength == 2) {
        var option1 = self.closest('.wc_variant_options_row').querySelectorAll('.wc_variant__single_options_row')[0].querySelector('.wc_swatch_button:checked').value;
        var option2 = self.closest('.wc_variant_options_row').querySelectorAll('.wc_variant__single_options_row')[1].querySelector('.wc_swatch_button:checked').value;
        self.closest('.wc_common_product_grid_class').querySelectorAll('.wc_main_variants option').forEach(function(selfInner){
          var select_option1 = selfInner.getAttribute('data-option1');
          var select_option2 = selfInner.getAttribute('data-option2');
          if (option1 == select_option1 && option2 == select_option2) {
              self.closest('.wc_common_product_grid_class').querySelectorAll('.wc_main_variants option').forEach(function(selfInner2){
                selfInner2.removeAttribute('selected');
              });
              selfInner.setAttribute('selected', 'selected');
             updatePricing(self.closest('.wc_main_grid_inner'));
          }
        });
      }
      if (optionsLength == 1) {
        var option1 = self.closest('.wc_variant_options_row').querySelectorAll('.wc_variant__single_options_row')[0].querySelector('.wc_swatch_button:checked').value;
        self.closest('.wc_common_product_grid_class').querySelectorAll('.wc_main_variants option').forEach(function(selfInner){
          var select_option1 = selfInner.getAttribute('data-option1');
          if (option1 == select_option1) {
              self.closest('.wc_common_product_grid_class').querySelectorAll('.wc_main_variants option').forEach(function(selfInner2){
                selfInner2.removeAttribute('selected');
              });
              selfInner.setAttribute('selected', 'selected');
              updatePricing(self.closest('.wc_main_grid_inner'));
          }
        });
      }
      if (self.closest('.wc_common_product_grid_class').querySelectorAll('.wc_grid_figure_images').length) {
        updateImages(self.closest('.wc_common_product_grid_class'));
      }
      updateErrorMessage(self.closest('.wc_main_comman_class'));
    });
  });
  document.querySelectorAll('.wc_single_option_selector').forEach(function(self){
    self.addEventListener('change', function(event){
      event.preventDefault();
      event.stopPropagation();
      var optionsLength = self.closest('.wc_variant_options_row').querySelectorAll('.wc_variant__single_options_row').length;
      if (optionsLength == 3) {
        var option1 = self.closest('.wc_variant_options_row').querySelectorAll('.wc_variant__single_options_row')[0].querySelector('.wc_single_option_selector option:checked').value;
        var option2 = self.closest('.wc_variant_options_row').querySelectorAll('.wc_variant__single_options_row')[1].querySelector('.wc_single_option_selector option:checked').value;
        var option3 = self.closest('.wc_variant_options_row').querySelectorAll('.wc_variant__single_options_row')[2].querySelector('.wc_single_option_selector option:checked').value;
        self.closest('.wc_common_product_grid_class').querySelectorAll('.wc_main_variants option').forEach(function(selfInner){
          var select_option1 = selfInner.getAttribute('data-option1');
          var select_option2 = selfInner.getAttribute('data-option2');
          var select_option3 = selfInner.getAttribute('data-option3');
          if (option1 == select_option1 && option2 == select_option2 && option3 == select_option3) {
              self.closest('.wc_common_product_grid_class').querySelectorAll('.wc_main_variants option').forEach(function(selfInner2){
                selfInner2.removeAttribute('selected');
              });
              selfInner.setAttribute('selected', 'selected');
              updatePricing(self.closest('.wc_main_grid_inner'));
          }
        });
      }
      if (optionsLength == 2) {
        var option1 = self.closest('.wc_variant_options_row').querySelectorAll('.wc_variant__single_options_row')[0].querySelector('.wc_single_option_selector option:checked').value;
        var option2 = self.closest('.wc_variant_options_row').querySelectorAll('.wc_variant__single_options_row')[1].querySelector('.wc_single_option_selector option:checked').value;
        self.closest('.wc_common_product_grid_class').querySelectorAll('.wc_main_variants option').forEach(function(selfInner){
          var select_option1 = selfInner.getAttribute('data-option1');
          var select_option2 = selfInner.getAttribute('data-option2');
          if (option1 == select_option1 && option2 == select_option2) {
              self.closest('.wc_common_product_grid_class').querySelectorAll('.wc_main_variants option').forEach(function(selfInner2){
                selfInner2.removeAttribute('selected');
              });
              selfInner.setAttribute('selected', 'selected');
              updatePricing(self.closest('.wc_main_grid_inner'));
          }
        });
      }
      if (optionsLength == 1) {
        var option1 = self.closest('.wc_variant_options_row').querySelectorAll('.wc_variant__single_options_row')[0].querySelector('.wc_single_option_selector option:checked').value;
        self.closest('.wc_common_product_grid_class').querySelectorAll('.wc_main_variants option').forEach(function(selfInner){
          var select_option1 = selfInner.getAttribute('data-option1');
          if (option1 == select_option1) {
              self.closest('.wc_common_product_grid_class').querySelectorAll('.wc_main_variants option').forEach(function(selfInner2){
                selfInner2.removeAttribute('selected');
              });
              selfInner.setAttribute('selected', 'selected');
              updatePricing(self.closest('.wc_main_grid_inner'));
          }
        });
      }
      if (self.closest('.wc_common_product_grid_class').querySelectorAll('.wc_grid_figure_images').length) {
        updateImages(self.closest('.wc_common_product_grid_class'));
      }
      updateErrorMessage(self.closest('.wc_main_comman_class'));
    });
  });
  const updateErrorMessage = (th_main_grid) => {
    var wc_want_to_disable_button = false;
    if (th_main_grid.querySelector('.wc_ajax_array')) {
      th_main_grid.querySelector('.wc_ajax_array').innerHTML = '';
    }
    th_main_grid.querySelectorAll('.wc_this_is_active_at_the_moment .wc_common_product_grid_class').forEach(function(self){
      var wc_selected_index = self.querySelector('.wc_main_variants').selectedIndex;
      var wc_title = self.querySelector('.wc_main_variants').options[wc_selected_index].text;
      var wc_available = self.querySelector('.wc_main_variants').options[wc_selected_index].getAttribute('data-available') === 'true' ? 1 : 0;
      if (!wc_available) {
        var wc_product_title = self.querySelector('.wc_common_product_grid_class') ? self.querySelector('.wc_common_product_grid_class').getAttribute('data-product-title') : self.getAttribute('data-product-title');
        if (wc_title !== 'Default Title') {
          wc_product_title += ' (' + wc_title + ')';
        }
        var wc_text = th_main_grid.querySelector('.wc_ajax_array').getAttribute('data-msg');
        wc_text = wc_text.replace('{{title}}', wc_product_title);
        var arewegoingtoshow = true;
        th_main_grid.querySelectorAll('.th_ajax_error_cls').forEach(function(self){
          if (self.innerHTML == wc_text) {
            arewegoingtoshow = false;
          }
        })
        if (arewegoingtoshow) {
          if (th_main_grid.querySelector('.wc_ajax_array')) {
            th_main_grid.querySelector('.wc_ajax_array').innerHTML = th_main_grid.querySelector('.wc_ajax_array').innerHTML + '<p class="th_ajax_error_cls">'+ wc_text +'</p>'
          }
        }
        wc_want_to_disable_button = true;
      }
    });
    if (wc_want_to_disable_button) {
      th_main_grid.querySelector('.wc_add_to_cart_button').classList.add('th_pb_add_to_cart_disabled');
    } else {
      if (th_main_grid.querySelectorAll('.th_pb_add_to_cart_disabled').length) {
        th_main_grid.querySelector('.wc_add_to_cart_button').classList.remove('th_pb_add_to_cart_disabled');
      }
    }
  }
  document.querySelectorAll('.wc_main_comman_class').forEach(function(self){
    updateErrorMessage(self);
  });
  const updateImages = (selfBox) => {
    var value = selfBox.querySelector('.wc_main_variants').options[selfBox.querySelector('.wc_main_variants').selectedIndex].text;
    var update_image = selfBox.querySelector('.wc_main_variants').options[selfBox.querySelector('.wc_main_variants').selectedIndex].getAttribute('data-image');
    if (update_image) {
      selfBox.querySelector('.wc_grid_figure_images').setAttribute('src', update_image);
    }
  }
  document.querySelectorAll('.wc_add_to_cart_button').forEach(function(self){
    self.addEventListener('click', function(){
      if (self.classList.toString().includes('th_pb_qty_layout_grid_btn_cls')) {
        self.classList.add('th_pb_qty_btn_loading');
      } else {
        self.classList.add('th_pb_btn_loading');
      }
      var main_container_id = self.closest('.wc_main_comman_class').getAttribute('data-bundle-id');
      var main_class = self.closest('.wc_main_comman_class');
      var bundle_title = self.closest('.wc_main_comman_class').querySelector('.wc_this_is_active_at_the_moment').getAttribute('data-main-title');
      var wc_bundle_id = self.closest('.wc_main_comman_class').getAttribute('data-bundle-number-id');
      var passing_value = self.closest('.th_pb_qty_bundle_cls') ? 'shquantity_' + wc_bundle_id + '_' + main_container_id : 'shproduct_' + wc_bundle_id + '_' + main_container_id;
      var main_list = [];
      main_class.querySelectorAll('.wc_this_is_active_at_the_moment .wc_main_variants').forEach(function(selfInner){
        var selected_variant_id = parseInt(selfInner.selectedOptions[0].value);
        var findSelected_index = main_list.findIndex(item => item.id == selected_variant_id);
        var quantity = parseInt(selfInner.getAttribute('data-quantity'));
        if (findSelected_index < 0) {
          var create_adding_variant = { 'id': selected_variant_id, 'quantity': quantity, 'properties': { "_th_bundle_uid": passing_value, "_th_bundle": bundle_title } }
          main_list.push(create_adding_variant);
        } else {
          main_list[findSelected_index].quantity = main_list[findSelected_index].quantity + quantity;
        }
      });
      $th_pb_click_analyst2(wc_bundle_id);
      wc_addItemsToCart(self, main_list);
    });
  });
  const $th_pb_click_analyst2 = function($th_addtocart_bundle_id) {
      fetch($th_app_ajax_url2+'bundle-ci/front-api/cart_click_analyst', {
          method: 'POST',
          keepalive: true,
          body: JSON.stringify({shop: Shopify.shop, bundle_id:$th_addtocart_bundle_id})
      }).then(response => response.json()).then($th_click_analyst => {}).catch(($th_click_analyst_error) => {
          console.error($th_click_analyst_error);
      });
  }
    const wc_addItemsToCart = async (wc_add_to_cart_button, wc_main_list) => {
        let formData = { 'items': wc_main_list };
        const th_response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(formData)
        })
        const myJson = await th_response.json();
        if (myJson) {
            if (wc_add_to_cart_button.closest('.wc_main_comman_class')) {
                var wc_add_to_cart_redirect = parseInt(wc_add_to_cart_button.closest('.wc_main_comman_class').getAttribute('data-add-to-cart-redirect'));
                if (wc_add_to_cart_redirect == 0) {
                    window.location.href = '/cart';
                } else if (wc_add_to_cart_redirect == 1) {
                    window.location.href = '/checkout';
                } else if (wc_add_to_cart_redirect == 2) {
                    window.$th_bundle_addtocart_callback(wc_add_to_cart_button, myJson);
                } else {
                    window.location.href = '/cart';
                }
            }
        }
    }
  document.querySelectorAll('.th_pb_qty_single_btn_cls').forEach(function(self){
    self.addEventListener('click', function(){
      document.querySelector('.th_pb_qty_layout_grid').style.display = 'block';
      var quantity = parseInt(self.getAttribute('data-val'));
      self.closest('.th_pb_qty_bundle_cls').querySelectorAll('.th_pb_qty_layout_grid_column_section').forEach(function(selfInner){
        selfInner.setAttribute('style', 'display: none !important');
        if (selfInner.classList.toString().includes('wc_this_is_active_at_the_moment')) {
          selfInner.classList.remove('wc_this_is_active_at_the_moment');
        }
      });
      self.closest('.th_pb_qty_bundle_cls').querySelector('.th_pb_qty_layout_grid_column_length_' + quantity).setAttribute('style', 'display: flex !important');
      self.closest('.th_pb_qty_bundle_cls').querySelector('.th_pb_qty_layout_grid_column_length_' + quantity).classList.add('wc_this_is_active_at_the_moment');
      updateErrorMessage(self.closest('.th_pb_qty_bundle_cls'))
    });
  });
}
document.addEventListener("DOMContentLoaded", (event) => {
  if (document.querySelector('.wc_product_bundle_display_none')) {
    var wc_product_bundle_html = document.querySelector('.wc_product_bundle_display_none').innerHTML;
    if (wc_product_bundle_html && document.querySelectorAll('.th_pb_section').length > 0) {
      document.querySelector('.th_pb_section').innerHTML = wc_product_bundle_html;
    }
    document.querySelector('.wc_product_bundle_display_none').innerHTML = '';
  }
  if (document.querySelector('.wc_quantity_bundle_display_none')) {
    var wc_quantity_bundle_html = document.querySelector('.wc_quantity_bundle_display_none').innerHTML;
    document.querySelector('.wc_quantity_bundle_display_none').innerHTML = '';
    if (wc_quantity_bundle_html && document.querySelectorAll('.th_pb_qty_bundle_cls').length > 0) {
      document.querySelector('.th_pb_qty_bundle_cls').innerHTML = wc_quantity_bundle_html;
    }
  }
  wc_all_options();
});